import { Sidebar } from "primereact/sidebar";

import commonStyle from "../../content/CommonStyles.module.css";
import TextInput from "../Inputs/TextInput";
import useApi from "../../../Utils/BackendClient";
import { useFormik } from "formik";
import { DisplayErrors } from "../../../Utils/ErrorHandler";
import DropdownInput from "../Inputs/DropdownInput";
import { fieldTypesTranslation } from "../../../Utils/TranslationUtils";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import CustomDictionaryCreationSideBar from "./CustomDictionaryCreationSidebar";

const AttributeCreationSidebar = ({visible, onHide, toast, data, additionalActions}) => {

    const { createProductAttribute, fetchCustomDictionaries, updateProductAttribute } = useApi();

    const [customDictionaries, setCustomDictionaries ] = useState(null);
    const [cdSidebarVisible, setCdSidebarVisible] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {

        const getCustomDictionaries = async () => {
            const response = await fetchCustomDictionaries({
                first: 0,
                rows: 100,
                page: 1,
                sortField: null,
                sortOrder: null,
            });

            if (response.status === 200) {
                const convertedDictionaries = response.data.results.map(i => ({ value: i.id, label: i.name }));
                setCustomDictionaries(convertedDictionaries);
            }

            setIsLoaded(true);
        }

        if (visible && !isLoaded) {
            getCustomDictionaries();
        }
    }, [visible, fetchCustomDictionaries, isLoaded]);

    const formik = useFormik({
            initialValues: data ?? {
                name: null,
                type: null,
                description: null,
                dictionary: null
            },
            enableReinitialize: true,
            validate: values => {
                const errors = {};
    
                if (!values.name) {
                    errors.name = "Введіть назву атрибуту"
                }
    
                return errors;
            },
            onSubmit: async (values) => {
    
                const response = data ? await updateProductAttribute(values.id, values) : await createProductAttribute(values);
    
                const successStatus = data ? 200 : 201;
    
                if (response.status === successStatus) {
                    
                    if(data){
                        toast.current.show({ severity: "success", summary: "Успіх", detail: `Атрибут успішно відредаговано`, life: 3000 });
                    }
                    else{
                      toast.current.show({ severity: "success", summary: "Успіх", detail: `Атрибут успішно створено`, life: 3000 });                  
                    }

                    formik.resetForm();
                    additionalActions();
                    onHide();
                }
                else {
                    DisplayErrors(response.error, toast);
                }
            }
        });

    const ResetCustomDictionaries = () => {
        setIsLoaded(false);
    }

    return (<>
        <Sidebar visible={visible} position="right" className={`${commonStyle.sidebar} ${cdSidebarVisible ? commonStyle.shortMoveLeft : ""}`} onHide={onHide} header={<h3>Меню додавання атрибуту</h3>}>
            <form onSubmit={formik.handleSubmit}>
                <TextInput formik={formik} paramName={"name"} label={"Назва атрибуту"} mandatory customStyle="w-full" />
                <DropdownInput
                    formik={formik}
                    paramName="type"
                    context={fieldTypesTranslation}
                    label="Тип поля"
                    onChange={(val) => formik.setFieldValue("type", val)}
                    customStyle="w-full"
                    mandatory />
                <TextInput formik={formik} paramName={"description"} label={"Опис"} customStyle="w-full" />
                {formik.values.type === "DICTIONARY" && <DropdownInput
                    formik={formik}
                    paramName="dictionary"
                    context={customDictionaries}
                    onChange={(val) => formik.setFieldValue("dictionary", val)}
                    label="Довідник"
                    customStyle="w-full"
                    addButton={true}
                    addButtonTooltip={"Додати атрибут"}
                    addButtonAction={() => setCdSidebarVisible(true)}
                    mandatory
                />}
                <Button label="Зберегти" severity="success" type="submit" className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
            </form>
            <CustomDictionaryCreationSideBar visible={cdSidebarVisible} onHide={() => setCdSidebarVisible(false)} additionalActions={() => ResetCustomDictionaries()} toast={toast}/>
        </Sidebar>
    </>);
}

export default AttributeCreationSidebar;